module.exports = __webpack_public_path__ + "img/river-rock-walk.85a755f6.webp";